import { ClipboardDocumentCheckIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { ReactNode } from "react";

import Headline from "~/components/Headline";
import { useCopyStyled } from "~/hooks/useCopyStyled.ts";

type Props = { children: ReactNode; };

const InvoiceNumberHeader = ({ children }: Props) => {
	const { copyToClipboard, copied, targetRef } = useCopyStyled({ includeFormatting: false });
	const ClipboardIcon = copied ? ClipboardDocumentCheckIcon : ClipboardDocumentIcon;
	return <button onClick={copyToClipboard}
				   className="group relative overflow-hidden">
		<Headline type="h2"
				  className="flex shrink items-center gap-2">
			<div ref={targetRef} className="min-w-0 truncate">{children}</div>
			<ClipboardIcon className={clsx("size-6 shrink-0", copied ? "text-success-600" : "text-gray-500")} />
		</Headline></button>;
};

export default InvoiceNumberHeader;